import { createReducer } from '@reduxjs/toolkit';

import { BankAccountResponse } from '../../services/api/dto/Accounts';
import { CompanyInfoStateType } from '../../types';
import {
  getBanksAccounts,
  getCompanies,
  getCompanyInfo,
} from '../actions/company-info';

const initialState: CompanyInfoStateType = {
  companies: {},
  banksAccounts: {},
};

const companyInfoReducer = createReducer(initialState, (builder) => {
  builder.addCase(getCompanyInfo.fulfilled, (state, action) => {
    if (action.payload) {
      state.companies[action.payload?.id] = action.payload;
    }
  });

  builder.addCase(getCompanies.fulfilled, (state, action) => {
    if (action.payload) {
      action.payload.forEach((value) => {
        state.companies[value.id] = value;
      });
    }
  });

  builder.addCase(getBanksAccounts.fulfilled, (state, action) => {
    if (action.payload) {
      const banks: Record<number, BankAccountResponse> = {};
      action.payload.forEach((account) => {
        banks[account.id] = account;
      });
      state.banksAccounts = banks;
    }
  });
});

export default companyInfoReducer;
